export default {
  data() {
    return {
      previousStep: Registration.previousStep,
      nextStep: Registration.nextStep,
      endUrl: Registration.endUrl,
    };
  },
  methods: {
    previous() {
      if (this.previousStep) {
        window.location.replace(this.previousStep.url);
      }
    },
    next() {
      if (this.nextStep) {
        window.location.replace(this.nextStep.url);
      } else {
        window.location.replace(this.endUrl);
      }
    }
  }
};
